import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-msgm-api-lib',
  template: `
    <p>
      msgm-api-lib works!
    </p>
  `,
  styles: []
})
export class MsgmApiLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
